import {ID, Response} from "../../../../../_metronic/helpers";
import {PostType} from "../../../Post/Post-List/core/_model";

export type PageModel = {
    id?: ID,
    title?: string,
    shortDescription?: string,
    description?: string,
    content?: string,
    postType?: PostType,
    keys?: string,
    userID?: number,
    dateTime?: Date,
    lastUpdate?: Date,
    picName?: string,
    dateString?: string,
    url?:string,
    pageContent ?:PageContent[]
}
export type UsersQueryResponse = Response<Array<PageModel>>
export const initialPage : PageModel = {
    title : '',
    dateString : '',
    userID : 0 ,
    content : '',
    keys :'',
    description : '',
    postType : PostType.Draft
}


export type PageContent = {
    tagType ?: TagType,
    content ?: string,
    sectionId? : number
    sectionTitle ?: string ,
    sectionImg?:string,
    child ?:PageContent []
}
export enum TagType {

    HtmlContent,
    Section,
    Row ,
    Col_1,
    Col_2,
    Col_3,
    Col_4,
    Col_5,
    Col_6,
    Col_7,
    Col_8,
    Col_9,Col_10,Col_11,Col_12
}